import { createContext, useContext } from "react";
import { useSocket } from "../hooks";
const Context = createContext();

export const SocketProvider = ({ children }) => {
  return <Context.Provider value={useSocket()}>{children}</Context.Provider>;
};

export const useSocketContext = () => useContext(Context);
